import { Routing, Search } from "@common/_constants";
import { Job as JobModel, TileSize } from "@common/models";
import { JobService } from "@pro/_services";
import { DashboardTile } from "@pro/components/Organisms/DashboardTile";
import React, { Component } from "react";
import { Link } from "react-router-dom";

const DashboardTileMyJobsNav = () => (
    <div className="c-dashboard__tile-nav">
        <Link
            to={`${Routing.Client.Pro.Jobs.SEARCH}/?${Search.FacetType.JOB_SEARCH_SCOPE.key}=${
                Search.JobSearchScope.MY
            }`}
            className="c-link no-underline">
            view all my jobs
        </Link>
    </div>
);

interface MyJobsState {
    jobs: {
        status: string;
        response: JobModel[];
    };
}
export class MyJobs extends React.Component<any, MyJobsState> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);
        this.state = {
            jobs: {
                status: "pending",
                response: [] as JobModel[],
            },
        };
        this.fetchJobs = this.fetchJobs.bind(this);
    }

    componentDidMount() {
        this.fetchJobs();
    }

    fetchJobs() {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.getMyJobs) {
            this._abortControllers.getMyJobs.abort();
        }
        this._abortControllers.getMyJobs = new AbortController();
        const signal = this._abortControllers.getMyJobs.signal;

        JobService.getMyJobs(signal).then(resp => {
            const state = { jobs: { status: "success", response: resp.results } };
            this.setState(state);
        });
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key => abortControllers[key].abort());
        }
    }

    render() {
        const { jobs } = this.state;
        return (
            <DashboardTile
                title="my jobs"
                description={
                    jobs.status === "success" && jobs.response.length > 0
                        ? jobs.response.length + " jobs"
                        : "keep track of your jobs"
                }
                size={TileSize.sm}
                loading={jobs!.status === "pending"}
                nav={
                    jobs.status === "success" &&
                    jobs.response.length > 0 && <DashboardTileMyJobsNav />
                }>
                {jobs.status === "success" &&
                    jobs.response.map(job => (
                        <div className="c-dashboard__block" key={job.job_id}>
                            <div className="c-dashboard__block-header">
                                <div className="c-dashboard__block-title">
                                    <Link
                                        className="c-link c-link--magenta"
                                        to={"/jobs/" + job.job_id}>
                                        {job.job_name}
                                    </Link>
                                </div>
                                <div className="c-dashboard__block-callout">
                                    {job.total_commission_in_us_dollars}
                                    {job.total_commission_in_us_dollars !== "" ? (
                                        <span>
                                            <br />
                                            referral reward
                                        </span>
                                    ) : (
                                        "referral reward not available"
                                    )}
                                </div>
                            </div>
                            <div className="c-dashboard__block-body">
                                <ul>
                                    <li>{job.primary_job_position_display_name}</li>
                                    <li>{job.location}</li>
                                </ul>
                            </div>
                        </div>
                    ))}
                {jobs.status === "success" &&
                    jobs.response.length === 0 && (
                        <div className="c-dashboard__blank">
                            <p className="u-text-gray">
                                Find jobs that match your network and when you refer or apply, they
                                appear here.
                            </p>
                            <div className="u-text-center">
                                <Link
                                    className="c-button c-button--blue"
                                    to={Routing.Client.Pro.Jobs.SEARCH}>
                                    browse jobs
                                </Link>
                            </div>
                        </div>
                    )}
            </DashboardTile>
        );
    }
}
